import {Link} from "react-router-dom";
import {DateGroupedIntervention} from "../../../utils/date";
import {getTicketStatusColor, ticketStatusOptions} from "../../../utils/status";

const TicketCard = ({ticket}) => {
  return (
    <div className="w-full bg-white !rounded-xl p-4 flex flex-col gap-1 relative overflow-hidden">
      <div className="flex items-center justify-between gap-2">
        <Link
          to={`/reclamation/${ticket?.id}`}
          title={ticket?.title}
          className="text-[#19295C] text-base font-medium truncate hover:underline"
        >
          {ticket?.title ?? "Titre de la reclamation"}
        </Link>
        <div
          className="text-xs w-fit font-medium text-nowrap py-[5px] px-4 rounded-full"
          style={{
            backgroundColor: getTicketStatusColor({
              status: ticket?.status,
            }).bg,
            color: getTicketStatusColor({status: ticket?.status}).color,
          }}
        >
          {
            ticketStatusOptions.find((tick) => tick.value === ticket?.status)
              .label
          }
        </div>
      </div>
      <div className="text-[#7e7e7e] text-xs flex items-center gap-2 !mb-1">
        <i className="fi fi-rr-calendar flex items-center"></i>
        {DateGroupedIntervention(ticket.updatedAt)}
      </div>

      <div className="text-[#7e7e7e] text-xs">
        {ticket?.TicketMessages[0]?.message ?? "--"}
      </div>

      <Link
        to={`/reclamation/${ticket?.id}`}
        className="absolute bottom-0 right-0 pt-3 pb-2 pl-3 pr-2 text-xl text-white bg-[#1A64B9] cursor-pointer !rounded-tl-full"
      >
        <i className="fi fi-tr-arrow-small-up rotate-45 flex items-center"></i>
      </Link>
    </div>
  );
};

export default TicketCard;
